import React from 'react';
import MusicTable from './compnents/music-table/music-table';

const Music: React.FC = () => {
  return (
    <div className="w-full h-full">
      <MusicTable />
    </div>
  );
};

export default Music;
